'use client'

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    return (
        <html>
            <body>
                <div className="flex min-h-screen items-center justify-center p-4">
                    <div className="text-center space-y-6">
                        <div className="space-y-2">
                            <h2 className="text-3xl font-bold">Critical Error</h2>
                            <p className="text-muted-foreground">
                                Something went wrong at the application level.
                            </p>
                        </div>

                        {process.env.NODE_ENV === 'development' && error.message && (
                            <div className="rounded-lg bg-red-100 p-4 text-left max-w-md mx-auto">
                                <p className="text-sm font-mono text-red-900">{error.message}</p>
                            </div>
                        )}

                        <button
                            onClick={() => reset()}
                            className="px-6 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
                        >
                            Reload Application
                        </button>
                    </div>
                </div>
            </body>
        </html>
    )
}
